import React, { useState, useEffect } from "react"
import { Grid, useMediaQuery } from "@material-ui/core"
import "./questionnaires-administration-duplicate-questionnaire-view.css"
import { ButtonHLPure, DialogSystemGLPure, DropDownBtnHLPure, InputHLPure, SimpleLoading, TextAreaHLPure } from "../../pures"
import { NIL as NIL_UUID } from 'uuid'
import { QuestionnaireService, ContractService } from "../../../services"
import { useTranslation } from "react-i18next"


const QuestionnairesAdministrationDuplicateQuestionnaireView = ({
    selectedQuestionnaire,
    user,
    token,
    companysForUser,
    hideShowDetails,
    showDetailComponent,
    companySelected,
    toggleCompleteRequest,
    toggleShowDetailComponent,
    showCompletedRequest,
    imageTitle,
    templateSelected,
    toggleErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    showLoadingRequesting,
    setShowComponentDetail,
    setStateNameComponentUser,
    setHeaderTitleinDetail,
    setNameComponentUser,
    setShowDetails,
    idTemplateDuplicate,
    templates,
    nameComponentUser

}) => {

    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:560px)")

    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [showGettingData, setShowGettingData] = useState(false);
    const [nameVoidWarning, setNameVoidWarning] = useState(false);
    const [company, setCompany] = useState(NIL_UUID)
    const [showLoadingRequest, setShowLoadingRequest] = useState(false);
    const [error, setError] = useState(false);
    const [showWarningRequesting, setShowWarningRequesting] = useState(false);
    const [messageError, setMessageError] = useState('')
    const [templateName, setTemplateName] = useState('Sin template')
    const [idTemplate, setIdTemplate] = useState(NIL_UUID)
    const [idCompany, setIdCompany] = useState(NIL_UUID)
    const [showCompnys, setShowCompanys] = useState([])

    useEffect(() => {
        if (companySelected && companySelected.length > 0) {
            setCompany(companySelected[0].id)
        }
    }, [companySelected])

    const handleNameQuestionnaire = (e) => {
        setName(e.target.value)
    }

    const handleDescription = (e) => {
        setDescription(e.target.value)
    }

    const searchChangeCompany = (e) => {
        setCompany(e.target.value)
    }


    const toggleWarningRequesting = () => {
        setShowWarningRequesting(false)
    }

    const handleDuplicateQuestionnaire = async () => {
        if (name === '') {
            setNameVoidWarning(true)
            setMessageError(t("questionnairesAdministrationNewQuestionnaireView.input.name.warning.label"))
            setTimeout(() => {
                setNameVoidWarning(false)
            }, 2000);
        } else {
            await toggleLoadingRequesting(true)
            let clientId = user.userMetaData.userA3Cloud.clientId
            let userId = user.userMetaData.userA3Cloud.clientId;
            let questionnaireId = selectedQuestionnaire ? selectedQuestionnaire.id : NIL_UUID

            //duplicate questionnaire
            let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);
            let contractService = new ContractService(process.env.REACT_APP_MIFIRMA_API);
            try {
                let questionnaireDuplicate = await questionnaireService.duplicateQuestionnaire(questionnaireId, clientId, name, company, token)
                if (questionnaireDuplicate && questionnaireDuplicate.statusCode === 200) {
                    let questionnaires = await contractService.getQuestionnairesByUserId(token, userId)
                    await toggleLoadingRequesting(false)
                    await toggleCompletedRequesting(true, '', questionnaires.data.data)
                    setTimeout(() => {
                        hideShowDetails()
                    }, 4000)
                } else if (questionnaireDuplicate.statusCode === -2) {
                    await toggleLoadingRequesting(false)
                    setMessageError(t("questionnairesAdministrationNewQuestionnaireView.error.modal.questionnaire.exist"))
                    toggleErrorRequesting(true)
                    setTimeout(() => {
                        toggleErrorRequesting(false)
                    }, 4000);
                } else {
                    await toggleLoadingRequesting(false)
                    await toggleErrorRequesting(true)
                    setTimeout(() => {
                        toggleErrorRequesting(false)
                    }, 4000);
                }
            } catch (error) {
                await toggleLoadingRequesting(false)
                await toggleErrorRequesting(true)
                setTimeout(() => {
                    toggleErrorRequesting(false)
                }, 3000);
            }
        }
    };

    useEffect(() => {
        if (nameComponentUser === t("questionnairesAdministrationEditDetailView.btn.duplicate.questionnaire")) {
            let nameDuplicate = selectedQuestionnaire.name + ' Duplicado'
            setName(nameDuplicate)
            setDescription(selectedQuestionnaire.description)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedQuestionnaire, templates])

    useEffect(() => {
        if (nameComponentUser === t("questionnairesAdministrationEditDetailView.btn.duplicate.questionnaire")) {
            //verify if exist template
            let temeplateSelected = templates.filter((template) => template.id === selectedQuestionnaire.template.id);
            if (temeplateSelected && temeplateSelected.length > 0) {
                setTemplateName(idTemplateDuplicate.name)
                setIdTemplate(idTemplateDuplicate.id)
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idTemplateDuplicate, templates])


    useEffect(() => {
        if (companySelected && companySelected[0] && companysForUser) {
            let companyFilter = companysForUser.filter((company) => company.id === companySelected[0].id)
            let newCompanys = companysForUser.filter((company) => company.id !== companySelected[0].id)
            newCompanys.unshift(companyFilter[0])
            setShowCompanys(newCompanys)
            setIdCompany(companySelected[0].id)
        } else {
            setShowCompanys(companysForUser)
        }
    }, [companySelected, companysForUser])

    useEffect(() => {

    }, [templates])


    return showGettingData ? (
        <div className="questionnairesAdministrationDuplicateQuestionnaireView-loader">
            <SimpleLoading />
        </div>
    ) : (
        <>
            <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className=""
            >

                {showLoadingRequesting ? <DialogSystemGLPure toggleLoadingRequesting={toggleLoadingRequesting} showLoadingRequesting={showLoadingRequesting} /> : null}
                {showCompletedRequesting ? (<DialogSystemGLPure showCompletedRequesting={showCompletedRequesting} toggleCompletedRequesting={toggleCompletedRequesting} />) : null}
                {nameVoidWarning ? <DialogSystemGLPure toggleWarningRequesting={toggleWarningRequesting} showWarningRequesting={nameVoidWarning} message={messageError} /> : null}
                {showErrorRequesting ? <DialogSystemGLPure toggleErrorRequesting={toggleErrorRequesting} showErrorRequesting={showErrorRequesting} message={messageError} /> : null}

                <div className="questionnairesAdministrationDuplicateQuestionnaireView-elements-container">
                    <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="questionnairesAdministrationDuplicateQuestionnaireView-container"
                    >
                        <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            className="questionnairesAdministrationDuplicateQuestionnaireView-container-left"
                        >

                            <DropDownBtnHLPure
                                labelDropDown={t("questionnairesAdministrationDuplicateQuestionnaireView.label.title.company")}
                                optionsDropDown={showCompnys}
                                onDropDownChange={(event) => searchChangeCompany(event)}
                                valueItem="id"
                                nameOption="companyName"
                            />

                            <InputHLPure
                                labelInput={t("questionnairesAdministrationDuplicateQuestionnaireView-label-questionnaire-title")}
                                typeInput={"text"}
                                valueInput={name}
                                tooltipShow
                                positionTooltip={isMobile ? "top" : "right"}
                                titleTooltip={t("questionnairesAdministrationDuplicateQuestionnaireView.questionnaire.tooltip.title")}
                                descriptionTooltip={t("questionnairesAdministrationDuplicateQuestionnaireView.questionnaire.tooltip.description")}
                                handleChangeInput={(e) => handleNameQuestionnaire(e)}
                                informationIcon={true}
                                inputActive={true}
                            />

                            <InputHLPure
                                labelInput={t("questionnairesAdministrationDuplicateQuestionnaireView.label.template.title")}
                                typeInput={"text"}
                                valueInput={templateName}
                                tooltipShow
                                positionTooltip={isMobile ? "top" : "right"}
                                titleTooltip={t("questionnairesAdministrationDuplicateQuestionnaireView.tooltip.template.title")}
                                descriptionTooltip={t("questionnairesAdministrationDuplicateQuestionnaireView.tooltip.template.description")}
                                // handleChangeInput = {(e) => handleNameQuestionnaire(e)}
                                informationIcon={true}
                                inputActive={true}
                                disabled
                            />
                        </Grid>
                        <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            className="questionnairesAdministrationDuplicateQuestionnaireView-textearea"
                        >
                            <TextAreaHLPure
                                labelTextArea={t("questionnairesAdministrationDuplicateQuestionnaireView.title.texarea")}
                                valueTextData={description}
                                handleChangeTextArea={(e) => handleDescription(e)}
                            />
                        </Grid>
                    </Grid>
                </div>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="questionnairesAdministrationDuplicateQuestionnaireView-container-btn"
                >
                    <div className="questionnairesAdministrationDuplicateQuestionnaireView-btns-margin">
                        <ButtonHLPure
                            nameBtn={t("button.cancel")}
                            onClickBtn={showDetailComponent ? toggleShowDetailComponent : hideShowDetails}
                        />
                    </div>
                    <ButtonHLPure
                        nameBtn={t("button.duplicate")}
                        primary
                        onClickBtn={handleDuplicateQuestionnaire}
                    />
                </Grid>
            </Grid>
        </>
    );
}
export default QuestionnairesAdministrationDuplicateQuestionnaireView;
